import { useContext } from 'react';
import { ApplicationContext } from './ApplicationContext';
import { ApplicationDispatchContext } from './ApplicationDispatchContext';
import { DispatchApplicationAction } from '../actions';
import { IApplicationData } from '../interfaces';

export const useApplicationContext = (): [IApplicationData, DispatchApplicationAction] => {
  const context = useContext(ApplicationContext);
  const dispatch = useContext(ApplicationDispatchContext);
  if (context === undefined || dispatch === undefined) {
    throw new Error('useApplicationContext must be used within a ApplicationProvider');
  }
  return [context, dispatch];
};
